import {
  ChevronRight,
  Plane,
  Users,
  Shield,
  Award,
  Target,
  Briefcase,
  Heart,
  CheckCircle,
  Globe,
  Handshake,
  Car,
} from 'lucide-react';
import { useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { Link } from "react-router-dom";
import Breadcrumb from '../components/Breadcrumb';
import { OrganizationSchema } from '../components/SchemaMarkup';

function About() {
  const [activeTab, setActiveTab] = useState('mission');
  const breadcrumbs = [
    { label: 'About Us', path: '/about' },
  ];

  return (
    <div className="font-[Arial] text-black">
      <OrganizationSchema />
      <Header />
      <Breadcrumb items={breadcrumbs} />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#000000] to-[#1a3c55] text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fadeInTop mt-10">
              About Moreflex Aviation
            </h1>
            <p className="text-lg mb-8 animate-fadeIn">
              Discover our story, mission, and the values that drive our
              commitment to excellence in aviation services.
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 animate-fadeInBottom">
              <Link
                to="/services"
                className="bg-[#73BDF2] text-white px-8 py-4 rounded hover:bg-[#5ba8e0] transition-colors duration-300 flex items-center justify-center"
              >
                Our Services <ChevronRight size={20} className="ml-2" />
              </Link>
              <Link
                to="/contact"
                className="border border-[#73BDF2] text-white px-8 py-4 rounded hover:bg-[#73BDF2]/10 transition-colors duration-300 flex items-center justify-center"
              >
                Contact Us <ChevronRight size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-[#73BDF2] rounded-full opacity-10 transform -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-[#73BDF2] rounded-full opacity-10 transform translate-x-1/4 translate-y-1/4"></div>
      </section>

      {/* Main About Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0 animate-fadeInLeft">
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1174&q=80"
                  alt="Airport terminal"
                  className="rounded-lg border-4 border-[#73BDF2] shadow-xl"
                />
                <img
                  src="https://images.unsplash.com/photo-1530521954074-e64f6810b32d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                  alt="Airport assistance"
                  className="absolute -bottom-10 -right-10 w-2/3 rounded-lg border-4 border-[#73BDF2] shadow-xl"
                />
                <div className="absolute -top-6 -left-6 bg-[#73BDF2] text-white p-4 rounded-full shadow-lg animate-pulse">
                  <Plane size={32} />
                </div>
              </div>
            </div>
            <div className="md:w-1/2 md:pl-16 animate-fadeInRight">
              <h2 className="text-3xl font-bold mb-6 relative">
                <span className="relative z-10">ABOUT US</span>
                <span className="absolute -z-10 left-0 bottom-0 w-16 h-3 bg-[#73BDF2]/30"></span>
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                At Moreflex Aviation Support Services we take pride in providing
                a world class meet and assist services, baggage assistance,
                lounge access services and transport across all African
                countries and beyond our borders.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Our airport assistance service can be tailored to suit royalty,
                VVIPs, VIPs, CIPs, business executives, diplomats, families
                travelling with infants, elderly travellers, and travellers with
                special needs.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                During our airport assistance service, you will receive full
                escort through airport related formalities, special hand baggage
                trolleys (on request), and a priority buggy car transfer through
                the airport terminal (on request and in areas where access is
                permitted by Civil Aviation Authorities).
              </p>

              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="flex items-center">
                  <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-3">
                    <Users className="text-[#73BDF2]" size={20} />
                  </div>
                  <span>VIP Services</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-3">
                    <Globe className="text-[#73BDF2]" size={20} />
                  </div>
                  <span>Global Reach</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-3">
                    <Shield className="text-[#73BDF2]" size={20} />
                  </div>
                  <span>Safety First</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-3">
                    <Award className="text-[#73BDF2]" size={20} />
                  </div>
                  <span>Premium Quality</span>
                </div>
              </div>

              <button className="bg-[#73BDF2] text-white px-6 py-3 rounded hover:bg-[#5ba8e0] transition-colors duration-300 flex items-center">
                Learn More <ChevronRight size={20} className="ml-2" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values Tabs */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                Our Mission, Vision & Values
              </h2>
              <p className="text-gray-600">
                The principles that guide us in delivering exceptional service
                to our clients
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              {/* Tabs */}
              <div className="flex border-b">
                <button
                  className={`flex-1 py-4 px-6 font-medium transition-colors duration-300 flex items-center justify-center ${
                    activeTab === 'mission'
                      ? 'bg-[#73BDF2] text-white'
                      : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveTab('mission')}
                >
                  <Target
                    size={18}
                    className={`mr-2 ${
                      activeTab === 'mission' ? 'text-white' : 'text-[#73BDF2]'
                    }`}
                  />
                  Our Mission
                </button>
                <button
                  className={`flex-1 py-4 px-6 font-medium transition-colors duration-300 flex items-center justify-center ${
                    activeTab === 'vision'
                      ? 'bg-[#73BDF2] text-white'
                      : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveTab('vision')}
                >
                  <Eye
                    size={18}
                    className={`mr-2 ${
                      activeTab === 'vision' ? 'text-white' : 'text-[#73BDF2]'
                    }`}
                  />
                  Our Vision
                </button>
                <button
                  className={`flex-1 py-4 px-6 font-medium transition-colors duration-300 flex items-center justify-center ${
                    activeTab === 'values'
                      ? 'bg-[#73BDF2] text-white'
                      : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveTab('values')}
                >
                  <Heart
                    size={18}
                    className={`mr-2 ${
                      activeTab === 'values' ? 'text-white' : 'text-[#73BDF2]'
                    }`}
                  />
                  Our Values
                </button>
              </div>

              {/* Tab Content */}
              <div className="p-8">
                {activeTab === 'mission' && (
                  <div className="animate-fadeIn">
                    <div className="flex items-center mb-6">
                      <div className="bg-[#73BDF2]/20 p-3 rounded-full mr-4">
                        <Target size={24} className="text-[#73BDF2]" />
                      </div>
                      <h3 className="text-xl font-bold">Our Mission</h3>
                    </div>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      To provide exceptional worldclass service to our customers
                      through dedication, excellence and accountability.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="bg-[#73BDF2]/20 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto">
                          <Award size={24} className="text-[#73BDF2]" />
                        </div>
                        <h4 className="font-bold text-center mb-2">
                          Excellence
                        </h4>
                        <p className="text-sm text-center text-gray-600">
                          Delivering the highest quality service in every
                          interaction
                        </p>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="bg-[#73BDF2]/20 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto">
                          <CheckCircle size={24} className="text-[#73BDF2]" />
                        </div>
                        <h4 className="font-bold text-center mb-2">
                          Dedication
                        </h4>
                        <p className="text-sm text-center text-gray-600">
                          Committed to going above and beyond for our clients
                        </p>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="bg-[#73BDF2]/20 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto">
                          <Briefcase size={24} className="text-[#73BDF2]" />
                        </div>
                        <h4 className="font-bold text-center mb-2">
                          Accountability
                        </h4>
                        <p className="text-sm text-center text-gray-600">
                          Taking responsibility for delivering on our promises
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'vision' && (
                  <div className="animate-fadeIn">
                    <div className="flex items-center mb-6">
                      <div className="bg-[#73BDF2]/20 p-3 rounded-full mr-4">
                        <Eye size={24} className="text-[#73BDF2]" />
                      </div>
                      <h3 className="text-xl font-bold">Our Vision</h3>
                    </div>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      To be the global leader in aviation industry services and
                      solutions, by understanding and tailoring our customers'
                      needs and working in teams to deliver service that exceeds
                      expectations.
                    </p>
                    <div className="bg-[#73BDF2]/5 p-6 rounded-lg border border-[#73BDF2]/20 mt-6">
                      <div className="flex items-start">
                        <Globe
                          size={24}
                          className="text-[#73BDF2] mr-4 mt-1 flex-shrink-0"
                        />
                        <div>
                          <h4 className="font-bold mb-2">Global Leadership</h4>
                          <p className="text-gray-600">
                            We aim to set the standard for excellence in
                            aviation services worldwide, becoming the first
                            choice for travelers seeking premium assistance
                            across all continents.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'values' && (
                  <div className="animate-fadeIn">
                    <div className="flex items-center mb-6">
                      <div className="bg-[#73BDF2]/20 p-3 rounded-full mr-4">
                        <Heart size={24} className="text-[#73BDF2]" />
                      </div>
                      <h3 className="text-xl font-bold">Our Core Values</h3>
                    </div>

                    <div className="space-y-6">
                      <div className="bg-gray-50 p-6 rounded-lg">
                        <div className="flex items-start">
                          <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-4 mt-1">
                            <Handshake size={24} className="text-[#73BDF2]" />
                          </div>
                          <div>
                            <h4 className="font-bold mb-2">INTEGRITY</h4>
                            <p className="text-gray-700">
                              We are proud to practice ethical and professional
                              business. Our word is an unbreakable promise, and
                              when we commit to mutually agreed-on processes, we
                              make certain that we operate above board, within
                              budget, and follow the rules of professional
                              conduct.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-gray-50 p-6 rounded-lg">
                        <div className="flex items-start">
                          <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-4 mt-1">
                            <Shield size={24} className="text-[#73BDF2]" />
                          </div>
                          <div>
                            <h4 className="font-bold mb-2">SAFETY</h4>
                            <p className="text-gray-700">
                              Our operational procedures draw on international
                              best practices of all-round safety for our
                              clients, staff and other partners. We are
                              regularly audited and certified by industry
                              associations, and our staff are up-to-date on
                              globally accepted safety and security standards.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-gray-50 p-6 rounded-lg">
                        <div className="flex items-start">
                          <div className="bg-[#73BDF2]/20 p-2 rounded-full mr-4 mt-1">
                            <Users size={24} className="text-[#73BDF2]" />
                          </div>
                          <div>
                            <h4 className="font-bold mb-2">TEAMWORK</h4>
                            <p className="text-gray-700">
                              We work best as dedicated teams providing bespoke
                              solutions. Our staff are trained to collaborate
                              with clients, while engaging among themselves to
                              deliver efficiency and exceptional service.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <p className="text-[#73BDF2] font-bold">OUR SERVICES</p>
            <h2 className="text-3xl font-bold mb-6">
              Comprehensive Aviation Support
            </h2>
            <p className="max-w-3xl mx-auto text-gray-600">
              We offer a wide range of premium services designed to make your
              travel experience seamless, comfortable, and stress-free from
              arrival to departure.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Service 1 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 group">
              <div className="h-3 bg-[#73BDF2]"></div>
              <div className="p-6">
                <div className="bg-[#73BDF2]/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#73BDF2]/20 transition-colors duration-300">
                  <Users size={32} className="text-[#73BDF2]" />
                </div>
                <h3 className="text-xl font-bold mb-4">Meet and Greet</h3>
                <p className="text-gray-600 mb-6">
                  Personalized welcome and assistance throughout your airport
                  journey, ensuring a smooth experience.
                </p>
                <a
                  href="#"
                  className="text-[#73BDF2] font-medium flex items-center group-hover:underline"
                >
                  Learn more <ChevronRight size={16} className="ml-1" />
                </a>
              </div>
            </div>

            {/* Service 2 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 group">
              <div className="h-3 bg-[#73BDF2]"></div>
              <div className="p-6">
                <div className="bg-[#73BDF2]/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#73BDF2]/20 transition-colors duration-300">
                  <Coffee size={32} className="text-[#73BDF2]" />
                </div>
                <h3 className="text-xl font-bold mb-4">Lounge Access</h3>
                <p className="text-gray-600 mb-6">
                  Exclusive access to premium lounges for comfort and relaxation
                  during your wait time.
                </p>
                <a
                  href="#"
                  className="text-[#73BDF2] font-medium flex items-center group-hover:underline"
                >
                  Learn more <ChevronRight size={16} className="ml-1" />
                </a>
              </div>
            </div>

            {/* Service 3 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 group">
              <div className="h-3 bg-[#73BDF2]"></div>
              <div className="p-6">
                <div className="bg-[#73BDF2]/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#73BDF2]/20 transition-colors duration-300">
                  <Car size={32} className="text-[#73BDF2]" />
                </div>
                <h3 className="text-xl font-bold mb-4">Transport Services</h3>
                <p className="text-gray-600 mb-6">
                  Luxury chauffeur and transportation services for seamless
                  travel to and from the airport.
                </p>
                <a
                  href="#"
                  className="text-[#73BDF2] font-medium flex items-center group-hover:underline"
                >
                  Learn more <ChevronRight size={16} className="ml-1" />
                </a>
              </div>
            </div>

            {/* Service 4 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 group">
              <div className="h-3 bg-[#73BDF2]"></div>
              <div className="p-6">
                <div className="bg-[#73BDF2]/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#73BDF2]/20 transition-colors duration-300">
                  <Briefcase size={32} className="text-[#73BDF2]" />
                </div>
                <h3 className="text-xl font-bold mb-4">Baggage Assistance</h3>
                <p className="text-gray-600 mb-6">
                  Professional handling of your luggage from arrival to
                  departure, including special requests.
                </p>
                <a
                  href="#"
                  className="text-[#73BDF2] font-medium flex items-center group-hover:underline"
                >
                  Learn more <ChevronRight size={16} className="ml-1" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#000000] to-[#1a3c55] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6 animate-fadeInTop">
              Ready to Experience Premium Airport Services?
            </h2>
            <p className="text-lg mb-8 animate-fadeIn">
              Contact us today to learn more about how we can enhance your
              travel experience with our premium services.
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 animate-fadeInBottom">
              <Link
                to="/services"
                className="bg-[#73BDF2] text-white px-8 py-4 rounded hover:bg-[#5ba8e0] transition-colors duration-300 flex items-center justify-center"
              >
                Book Our Services <ChevronRight size={20} className="ml-2" />
              </Link>
              <Link
                to="/contact"
                className="border border-[#73BDF2] text-white px-8 py-4 rounded hover:bg-[#73BDF2]/10 transition-colors duration-300 flex items-center justify-center"
              >
                Contact Us <ChevronRight size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#73BDF2] rounded-full opacity-10 transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#73BDF2] rounded-full opacity-10 transform -translate-x-1/4 translate-y-1/4"></div>
      </section>

      <Footer />
    </div>
  );
}

export default About;

// Missing component imports
function Eye(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={props.className}
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function Coffee(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={props.className}
    >
      <path d="M17 8h1a4 4 0 1 1 0 8h-1" />
      <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" />
      <line x1="6" x2="6" y1="2" y2="4" />
      <line x1="10" x2="10" y1="2" y2="4" />
      <line x1="14" x2="14" y1="2" y2="4" />
    </svg>
  );
}
